export const formatDayCountSeparated = (days) => {
    if (!days || days <= 0) {
        return { pocet: '0', jednotka: 'dní' };
    }
    if (days % 7 === 0 && days >= 7) {
        return { pocet: String(Math.floor(days / 7)), jednotka: days === 7 ? 'týden' : 'týdnů' };
    }
    return { pocet: String(days), jednotka: days === 1 ? 'den' : 'dní' };
};
//# sourceMappingURL=Formatter.js.map